'use client';

import { useEffect, useState } from 'react';
import Phone from 'react-phone-input-2';
import '@/styles/libs/react-phone-input-2.scss';

const PhoneInput = ({ inputClass, value, name, required, onChange }) => {
  const [country, setCountry] = useState('ua');
  const [inputKey, setInputKey] = useState(0);

  const customLocalization = {
    ua: {
      ua: 'Україна',
      pl: 'Польща',
      us: 'США',
      searchPlaceholder: 'Пошук країни...',
    },
  };

  useEffect(() => {
    if (!value) {
      setCountry('ua');
      setInputKey((prev) => prev + 1);
    }
  }, [value]);

  return (
    <div data-lenis-prevent={true} style={{ width: '100%' }}>
      <Phone
        key={inputKey}
        excludeCountries={['ru']}
        preferredCountries={['ua', 'pl', 'us']}
        country={country}
        autoFormat={true}
        enableSearch={true}
        disableSearchIcon={true}
        onChange={(val, data) => {
          onChange(val, data);
          setCountry(data?.countryCode || 'ua');
        }}
        inputProps={{
          required,
          name,
        }}
        disableCountryCode={false}
        countryCodeEditable={false}
        inputClass={inputClass}
        value={value}
        localization={customLocalization['ua']}
      />
    </div>
  );
};

export default PhoneInput;
